// extracted by mini-css-extract-plugin
module.exports = {"main":"layout_main__KhA0t","container":"layout_container__EEt3s","error-container":"layout_error-container__CGUC4"};